import { fromJS, Set } from 'immutable';
import type { AnyAction } from 'redux';

import { TypedMap } from 'utils/typed-map';

import {
  INIT,
  FETCH_FAILED,
  FETCH_SUCCESS,
  SET_FETCH_PARAMS,
  VERIFY,
  VERIFY_SUCCESS,
  VERIFY_FAILED,
  SEND_PAC_UPLOAD_EMAIL_NOTIFICATION,
  SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_SUCCESS,
  SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_FAILED,
} from './constants';

export type VolunteersPageState = TypedMap<{
  initialized: boolean;
  loading: boolean;
  error: boolean;
  fetchParams: {
    sort: string;
    order: string;
    search: string;
    pageNum: number;
    limit: number;
    status: any;
    departments: Set<string>;
    locations: Set<string>;
  };
  verifying: Set<string>;
  sendingPacUploadEmailNotification: boolean;
}>;

export const initialState = fromJS({
  initialized: false,
  loading: false,
  error: false,
  fetchParams: {
    sort: 'name',
    order: 'desc',
    search: '',
    pageNum: 0,
    limit: 10,
    status: null,
    departments: Set(),
    locations: Set(),
  },
  verifying: Set(),
  sendingPacUploadEmailNotification: false,
}) as VolunteersPageState;

function volunteersListPageReducer(state = initialState, action: AnyAction): VolunteersPageState {
  switch (action.type) {
    case INIT:
      return state.merge({ initialized: true, loading: true });

    case FETCH_FAILED:
      return state.merge({ loading: false, error: action.error });

    case FETCH_SUCCESS:
      return state.set('loading', false);

    case SET_FETCH_PARAMS:
      return state.merge({
        loading: true,
        fetchParams: state.get('fetchParams').merge({ pageNum: 0, ...action.params }),
      });

    case VERIFY:
      return state.set('verifying', state.get('verifying').add(action.userId));

    case VERIFY_SUCCESS:
    case VERIFY_FAILED:
      return state.set('verifying', state.get('verifying').delete(action.userId));

    case SEND_PAC_UPLOAD_EMAIL_NOTIFICATION:
      return state.set('sendingPacUploadEmailNotification', true);

    case SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_SUCCESS:
      return state.set('sendingPacUploadEmailNotification', false);

    case SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_FAILED:
      return state.set('sendingPacUploadEmailNotification', false);

    default:
      return state;
  }
}

export default volunteersListPageReducer;
